import {Hydra} from '../generic/hydra';

import {UtilisateurInterface} from './Utilisateur';
import {AideSousTypeInterface} from './AideSousType';
import {ProjetDureeInterface} from './ProjetDuree';
import {AideFormulaireInterface} from './AideFormulaire';
import {CommissionSeanceInterface} from './CommissionSeance';
import {AideFraisTypeDescriptionInterface} from './AideFraisTypeDescription';
import {AideFinancementInterface} from './AideFinancement';
import {Aide as AideBaseInterface} from '../../interface/api/Aide';

export type AideInterface = AideBaseInterface;

export class Aide extends Hydra implements AideInterface {

    translations?: any[] | null = [];

    id?: number | null;

    label?: string | null;

    code?: string | null;

    annee?: number | null;

    responsable?: UtilisateurInterface | string | null;

    responsableNom?: string | null;

    responsableEmail?: string | null;

    responsableTel?: string | null;

    aideSousType?: AideSousTypeInterface | string | null;

    alerte?: string | null;

    projetDurees?: (ProjetDureeInterface|string)[] | null = [];

    coeffCout?: number | null;

    montantMensuel?: number | null;

    montantAnnuel?: number | null;

    dateDebutSaisie?: string | null;

    dateFinSaisie?: string | null;

    nbAnnexes?: number | null;

    dateFinUploadAnnexes?: string | null;

    aideFormulaires?: AideFormulaireInterface[]|string[] | null = [];

    commissionSeances?: CommissionSeanceInterface[] | null = [];

    aideFraisTypes?: any[] | null = [];

    aideFraisTypeDescriptions?: AideFraisTypeDescriptionInterface[] | null = [];

    utilisateurAutorises?: UtilisateurInterface[] | null = [];

    aideFinancement?: AideFinancementInterface | string | null;

    aidePrecedente?: any | null;

    aideSuivante?: any | null;

    reventilable?: boolean | null = false;

    createur?: UtilisateurInterface | string | null;

    dateCreation?: string | Date | null;

    dateDerniereModification?: string | Date | null;

    utilisateurDerniereModification?: UtilisateurInterface | string | null;

    workflowCommissionsComplet?: boolean | null = false;

    nbEtapes?: number | null;

    currentEtape?: number | null;

    nbDossiers?: number;

    /* Objet de la classe Fichier, avec un fichierType 'public'
     */
    illustration?: any | null;

    protected?: boolean;

    hasModuleEquipeAssociee?: boolean;

    constructor(options: AideInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
